import React, { useEffect, useState, useRef } from "react"
import PropTypes from "prop-types"
import apexchart from "apexcharts";
import Dropzone from "react-dropzone"
import { getPlantData, getClimateData } from "../../store/design/actions"
import ReactApexChart from "react-apexcharts"
import { getAreas, updateArea, saveCustomPlant, updateCustomPlant, deleteArea, addArea } from "../../store/goals/actions"
import moment from 'moment';
import classnames from "classnames"
import { connect } from "react-redux"
import { v4 as uuidv4 } from 'uuid';
import dayjs from "dayjs";
import Editable from 'react-x-editable'
import DatePicker from "react-datepicker"
import Spreadsheet from "react-spreadsheet";
import { jsPDF } from 'jspdf';
import { useDrag, useDrop } from "react-dnd";
import {
  Badge,
  Col,
  Collapse,
  CardHeader,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Button,
  Container,
  Dropdown,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalHeader,
  ModalBody,
  Nav,
  NavItem,
  NavLink,
  Form,
  FormGroup,
  Label,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  TabContent,
  TabPane,
  Input,
} from "reactstrap"
import { withRouter, Link } from "react-router-dom"
import { map } from "lodash"
import { Image } from '@aws-amplify/ui-react'
import { StorageImage } from '@aws-amplify/ui-react-storage';
import { Storage } from '@aws-amplify/storage'
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    ReferenceArea,
    ResponsiveContainer
} from 'recharts';


const type = "Plant";

function normPhotos(note) {
    const arr = Array.isArray(note?.photos) ? note.photos : [];
    return arr.map(p => ({ s3_key: p?.s3_key || p?.s3Key || p?.key || "", comment: p?.comment || "" }))
              .filter(p => p.s3_key);
}

async function safeGet(key) {
    if (!key) return null;
    try { return await Storage.get(key); } catch {
        try { return await Storage.get(key, { level: "public" }); } catch { return null; }
    }
}

Storage.configure({ region: "us-east-1",
    bucket: "sagestoragetime145131-dev",
    identityPoolId: "us-east-1:f9b0a105-4efc-4052-ae45-ab1c15c9982a"});

const Plant = props => {
  const { plant, plantMap, areaIndex, currYear, addHarvest, deleteNote, deleteHarvest, noteTags, notes, noteDate, plantIndex, plantingCalendarOptions, calcPlantingCalendar,
    onGetCustomPlants, deletePlant, updateSpaceUsed, areas, setNoteDate, setNotes, setNoteTags, transferPlant, transferModal, setTransferModal, setAreas, userareas, climateAverages,  onUpdateArea, unitmeasurement, profile,
    onUpdateCustomPlant, onSaveCustomPlant, customPlantEdit, timelineNotes, onCreateJournalEntry, onUpdateJournalEntry } = props

  const [currHarvests, setCurrHarvests] = useState([])
  const [harvestPlotOptions, setHarvestPlotOptions] = useState({})
  const [currPlant, setCurrPlant] = useState({})
  const [saveCustomPlantModal, setSaveCustomPlantModal] = useState(false)
  const [customAreaIndex, setCustomAreaIndex] = useState()
  const [customPlantIndex, setCustomPlantIndex] = useState()
  const [singlebtn, setSinglebtn] = useState(false)
  const [plantModal, setPlantModal] = useState(false)
  const [isPlantEdit, setPlantEdit] = useState(false)
  const [editTab, setEditTab] = useState("info")
  const [plantInfo, setPlantInfo] = useState(false)
  const [plantDates, setPlantDates] = useState(false)
  const [plantHarvests, setPlantHarvests] = useState(false)
  const [plantNotes, setPlantNotes] = useState(false)
  const [species, setSpecies] = useState()
  const [showHarvests, setShowHarvests] = useState(false)
  const [variety, setVariety] = useState()
  const [name, setName] = useState()
  const [space, setTotalSpace] = useState()
  const [profileView, setProfileView] = useState(false)
  const [daysToHarvest, setDaysToHarvest] = useState()
  const [harvestAmount, setHarvestAmount] = useState()
    const [rechartsClimate, setRechartsClimate] = useState([]);
    const [minCold, setMinCold] = useState(null);
    const [maxHot, setMaxHot] = useState(null);
    const [harvestDate, setHarvestDate] = useState()
  const [harvestUnit, setHarvestUnit] = useState()
  const [numPlants, setNumPlants] = useState()
  const [seedStartDate, setSeedStartDate] = useState()
  const [actualSeedStartDate, setActualSeedStartDate] = useState()
  const [transplantDate, setTransplantDate] = useState()
  const [text, setText] = useState("")
  const [chartKey, setChartKey] = useState(0);
  const [plantStatus, setPlantStatus] = useState ()
  const [measurementScale, setMeasurementScale] = useState ("E")
  const [selectedFiles, setSelectedFiles] = useState([])
  const ref = useRef(null);
    const [noteError, setNoteError] = useState("");
    const [pendingPhotos, setPendingPhotos] = useState(null);
    const [photoUrlByKey, setPhotoUrlByKey] = useState({});
    const [lightboxUrl, setLightboxUrl] = useState(null);

    const username = JSON.parse(localStorage.getItem("user")).user


const labels = {
    "metric": {
         "weight": "kg",
         "temperature": "°C",
         "space": "sq. m",
         "distance": "cm"
       },
    "imperial": {
         "weight": "oz",
         "temperature": "°F",
         "space": "sq. ft",
         "distance": "in"
       }
}
  const plantProps = {
	  daysToHarvest: "Days To Harvest",
	  germinationTime: "Germination Time",
	  minimumTemp: "Minimum Temperature (" + labels[unitmeasurement].temperature + ")",
    maximumTemp: "Maximum Temperature (" + labels[unitmeasurement].temperature + ")",
    yield_per_plant_ounces: "Yield Per Plant (" + labels[unitmeasurement].weight + ")",
	  plant_family: "Plant Family",
	  season: "Growing Cycle",
	  size: "Size",
	  spacing_between_plants: "Spacing between Plants (" + labels[unitmeasurement].distance + ")"
  }

  const [{ isDragging }, drag] = useDrag(() => (
    {
    type: 'plant',
    item: { plant: plant, area: areaIndex  },
    collect: (monitor) => {
      return {
        isDragging: monitor.isDragging(),
      };
    },
  }));

  const plantSeasonOptions = [
          {"value": "Spring",
           "text": "Spring"},
          {"value": "Summer",
           "text": "Summer"},
          {"value": "Fall",
           "text": "Fall"},
          {"value": "Winter",
           "text": "Winter"}];

  const plantStatusOptions = [
	  {"value": "Purchased",
           "text": "Purchased"},
      {"value": "Not Started",
          "text": "Not Started"},
      {"value": "Seed Starting",
          "text": "Seed Starting"},
          {"value": "Transplanting",
           "text": "Transplanting"},
          {"value": "Growing",
           "text": "Growing"},
          {"value": "Harvesting",
           "text": "Harvesting"},
      {"value": "Failed",
          "text": "Failed"},
      {"value": "Complete",
          "text": "Complete"}];
 
  function loadProfileView() {
      setProfileView(true)
  }

    function toRechartsData(series, seedISO, harvestISO) {
        // --- 1. Defensive checks ---
        if (!series || !Array.isArray(series)) {
            console.warn("toRechartsData: invalid climate series", series);
            return [];
        }
        if (!seedISO || !harvestISO) {
            console.warn("toRechartsData: missing seed or harvest date", seedISO, harvestISO);
            return [];
        }

        // Convert to Date objects in UTC-normalized format
        const seed = new Date(seedISO);
        const harvest = new Date(harvestISO);

        if (isNaN(seed) || isNaN(harvest)) {
            console.warn("toRechartsData: invalid date parsing", seedISO, harvestISO);
            return [];
        }

        // --- 2. Find the hot & cold series safely ---
        const hotSeries = series.find((s) => s?.name?.toLowerCase().includes("hot"));
        const coldSeries = series.find((s) => s?.name?.toLowerCase().includes("cold"));

        if (!hotSeries || !Array.isArray(hotSeries.data)) {
            console.warn("Missing hot climate data");
            return [];
        }
        if (!coldSeries || !Array.isArray(coldSeries.data)) {
            console.warn("Missing cold climate data");
            return [];
        }

        // Climate arrays MUST be 12 months long
        const hot = hotSeries.data;
        const cold = coldSeries.data;

        // --- 3. Build extended date range: -4 months to +4 months ---
        const MONTHS_BEFORE = 4;
        const MONTHS_AFTER = 4;

        // Use UTC months to avoid timezone shifts
        const start = new Date(Date.UTC(seed.getUTCFullYear(), seed.getUTCMonth() - MONTHS_BEFORE, 1));
        const end = new Date(Date.UTC(harvest.getUTCFullYear(), harvest.getUTCMonth() + MONTHS_AFTER, 1));

        const rows = [];
        let cursor = new Date(start);

        while (cursor <= end) {
            const year = cursor.getUTCFullYear();
            const month = cursor.getUTCMonth(); // 0–11

            // Map month → climate index safely
            const idx = month % 12;

            rows.push({
                date: cursor.getTime(), // <-- timestamp for Recharts
                iso: cursor.toISOString().split("T")[0], // <-- ISO YYYY-MM-DD
                hot: hot[idx] ?? hot.at(-1) ?? null,
                cold: cold[idx] ?? cold.at(-1) ?? null
            });

            // advance one month safely
            cursor = new Date(Date.UTC(year, month + 1, 1));
        }

        return rows;
    }

    // Resolve photo URLs whenever this plant's notes change
    useEffect(() => {
        const plantNotes = Array.isArray(timelineNotes) ? timelineNotes.filter(n => n.plant_id === plant.id) : [];
        let cancelled = false;
        (async () => {
            const toFetch = [];
            for (const n of plantNotes) {
                for (const p of normPhotos(n)) {
                    if (p.s3_key && !photoUrlByKey[p.s3_key]) toFetch.push(p.s3_key);
                }
            }
            if (!toFetch.length) return;
            const updates = {};
            for (const key of toFetch) {
                const url = await safeGet(key);
                if (url) updates[key] = url;
            }
            if (!cancelled && Object.keys(updates).length) setPhotoUrlByKey(prev => ({ ...prev, ...updates }));
        })();
        return () => { cancelled = true; };
    }, [timelineNotes]); // eslint-disable-line react-hooks/exhaustive-deps

    // Upload pending photos once the newly created note_id is known
    useEffect(() => {
        if (!pendingPhotos?.files?.length) return;
        const plantNotes = Array.isArray(timelineNotes) ? timelineNotes.filter(n => n.plant_id === plant.id) : [];
        const newNote = plantNotes.find(n =>
            n.date === pendingPhotos.dateKey &&
            (n.note_text || "") === (pendingPhotos.noteText || "") &&
            normPhotos(n).length === 0
        );
        if (!newNote?.note_id) return;
        const { files, dateKey } = pendingPhotos;
        setPendingPhotos(null);
        (async () => {
            try {
                const uploaded = [];
                for (const file of files) {
                    const key = `${username}/journal/${dateKey}/${newNote.note_id}/${Date.now()}_${file.name}`;
                    await Storage.put(key, file, { contentType: file.type });
                    const url = await safeGet(key);
                    if (url) setPhotoUrlByKey(prev => ({ ...prev, [key]: url }));
                    uploaded.push({ s3_key: key, comment: "" });
                }
                onUpdateJournalEntry({ username, note_id: newNote.note_id, date: dateKey, photos: uploaded });
            } catch (e) { console.error("Photo upload failed:", e); }
        })();
    }, [timelineNotes, pendingPhotos]); // eslint-disable-line react-hooks/exhaustive-deps

    function addPlantLog() {
        const hasContent = noteDate || notes?.trim() || selectedFiles.length > 0;
        if (!hasContent) {
            setNoteError("Please add a note, date, or photo before saving.");
            return;
        }
        setNoteError("");

        const area = areas[areaIndex];
        const date = noteDate ? dayjs(noteDate).format("YYYY-MM-DD") : dayjs().format("YYYY-MM-DD");
        const noteText = notes?.trim() || "";

        if (selectedFiles.length > 0) {
            setPendingPhotos({ files: selectedFiles, dateKey: date, noteText });
            setSelectedFiles([]);
        }

        setNoteDate("");
        setNotes("");

        onCreateJournalEntry({
            username,
            area_id: area.id,
            plant_id: plant.id,
            note_text: noteText,
            date,
            photos: [],
        });
    }

  function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return "0 Bytes"
    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
  }

  function openSaveCustomPlantModal (areaIndex, plantIndex) {
      setCustomAreaIndex(areaIndex)
      setCustomPlantIndex(plantIndex)
      setSaveCustomPlantModal(true)
  }

    function getWindowYBounds(rechartsData, seedStart, harvestEnd) {
        const start = Date.parse(seedStart);
        const end = Date.parse(harvestEnd);

        const inRange = rechartsData.filter(d => d.date >= start && d.date <= end);

        const minCold = Math.min(...inRange.map(d => d.cold));
        const maxHot = Math.max(...inRange.map(d => d.hot));

        return { minCold, maxHot };
    }


    function editPlant (plant, areaIndex, plantIndex) {
      if (plant) {
          console.log(plant)
          setCurrPlant(plant)

          const rechartsData = toRechartsData(
              climateAverages,              // your useState with the Hot/Cold series
              plant.seedStartDate,          // e.g. "2025-05-11" or "5/11/2025"
              plant.harvestDate             // e.g. "2025-08-25"
          );
          setRechartsClimate(rechartsData);

          const seed = Date.parse(plant.seedStartDate);
          const harvest = Date.parse(plant.harvestDate);

          const findNearest = (targetTime, data) => {
              if (!Array.isArray(data) || data.length === 0) return null;
              if (isNaN(targetTime)) return null;

              return data.reduce((closest, row) => {
                  // row.date is a number (timestamp) in your current rechartsData
                  const rowTime = typeof row.date === "number" ? row.date : Date.parse(row.date);
                  const closestTime =
                      typeof closest.date === "number" ? closest.date : Date.parse(closest.date);

                  const diff = Math.abs(rowTime - targetTime);
                  const closestDiff = Math.abs(closestTime - targetTime);

                  return diff < closestDiff ? row : closest;
              }, data[0]); // <-- seed reduce with first element
          };

          const coldStartRow = findNearest(seed, rechartsData);
          const hotEndRow = findNearest(harvest, rechartsData);

          setMinCold(coldStartRow?.cold ?? 0);
          setMaxHot(hotEndRow?.hot ?? 100);

          var ndata = [{"name": "Harvests", "type": "bar", "data":[]}]
	 var labels = []
	 plant.harvests.forEach(element => {
	     ndata[0].data.push(element.amount)
             labels.push(element.date) 
	 })

      var options = {
          chart: {
             stacked: false,
             toolbar: {
                show: false,
             },
          },
          stroke: {
             width: [2,0],
             curve: "smooth",
          },
          colors: ["#99A88D"],
          fill: {
             opacity: [0.85, 0.25, 1],
             gradient: {
                inverseColors: false,
                shade: "light",
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100],
             },
          },
          markers: {
             size: 0,
          },
          legend: {
             offsetY: 11,
          },
          labels: labels,
          xaxis: {
             type: "datetime",
          },
          yaxis: {
             title: {
             text: "",
          },
      },
      tooltip: {
          shared: true,
          intersect: false
      },
      grid: {
          borderColor: "#f1f1f1",
      },
     }

	       setHarvestPlotOptions(options)
         setCurrHarvests(ndata)
      }
       setPlantModal(!plantModal)
  }

  function harvestChange (target) {
      if (target.props.name=="harvestDate") {
          setHarvestDate(target.newValue);
      } else if (target.props.name=="harvestAmount") {
          setHarvestAmount(target.newValue);
      } else {
	  setHarvestUnit(target.newVale);
      }
  }


  function plantChange (target) {
      var plant;
      if (!customPlantEdit) {
          plant = areas[areaIndex].plants[plantIndex]
      } else {
          plant = {...currPlant}
      }
      if (!plant.totalHarvest)
          plant.totalHarvest = 0
      if (plant.transplantDate && !plant.harvestDate) {
          var harvestDate = new Date(plant.transplantDate)
          harvestDate.setDate(harvestDate.getDate() + parseInt(plant.daysToHarvest))
          plant.harvestDate =  (harvestDate.getMonth() + 1) + '/' + (harvestDate.getDate()+1) + '/' + harvestDate.getFullYear();
      }
      if (target.props.name=="seedStartDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].seedStartDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          } else
              plant.seedStartDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
      } else if (target.props.name=="actualSeedStartDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].actualSeedStartDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          }
      } else if (target.props.name=="transplantDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].transplantDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          } else {
              plant.transplantDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
          }
      } else if (target.props.name=="actualTransplantDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].actualTransplantDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          }
      } else if (target.props.name=="harvestDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].harvestDate =  (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          } else {
              plant.harvestDate =  (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
          }
      } else if (target.props.name=="actualHarvestDate") {
          var newDate = new Date(target.newValue);
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex].actualHarvestDate = (newDate.getMonth() + 1) + '/' + (newDate.getDate()+1) + '/' +  newDate.getFullYear();
              setAreas(areas);
          }
      } else {
          if (!customPlantEdit) {
              areas[areaIndex].plants[plantIndex][target.props.name] = target.newValue;
              if (target.props.name=='yield_per_plant_ounces' || target.props.name=='numPlants' || target.props.name=='spacing_between_plants') {
                  var plant = areas[areaIndex].plants[plantIndex]
                  plant.estHarvest = plant['yield_per_plant_ounces'] * plant.numPlants / 16.0
                  var numPerSquareFoot = Math.pow(12/currPlant["spacing_between_plants"],2);
                  plant.spaceUsed = parseFloat(plant.numPlants/numPerSquareFoot).toFixed(2);
                  if (unitmeasurement=="metric") {
                      plant.spaceUsed = (plant.spaceUsed/10.764).toFixed(2)
                      plant.estHarvest = (plant.estHarvest/2.2).toFixed(2)
                      plant.yield_per_plant_ounces = (plant.yield_per_plant_ounces/35.274).toFixed(2)
                      plant.minimumTemp = ((plant.minimumTemp - 32)*5/9).toFixed(2)
                      plant.maximumTemp = ((plant.maximumTemp - 32)*5/9).toFixed(2)
                      plant["spacing_between_plants"] = (plant["spacing_between_plants"] / 2.54).toFixed(2)
                  }
              }
          } else {
              plant[target.props.name] = target.newValue
              plant.estHarvest = plant['yield_per_plant_ounces'] * plant.numPlants / 16.0
              var numPerSquareFoot = Math.pow(12/currPlant["spacing_between_plants"],2);
              plant.spaceUsed = (plant.numPlants/numPerSquareFoot).toFixed(2);
              if (unitmeasurement=="metric") {
                  plant.spaceUsed = (plant.spaceUsed/10.764).toFixed(2)
                  plant.estHarvest = (plant.estHarvest/2.2).toFixed(2)
                  plant.yield_per_plant_ounces =  (plant.yield_per_plant_ounces/35.274).toFixed(2)
                  plant.minimumTemp = ((currPlant.minimumTemp - 32)*5/9).toFixed(2)
                  plant.maximumTemp = ((currPlant.maximumTemp - 32)*5/9).toFixed(2)
                  plant["spacing_between_plants"] = (plant["spacing_between_plants"] / 2.54).toFixed(2)
              }
          }
      }
      if (!customPlantEdit) {
          // Keep the modal's bound currPlant in sync so edits don't revert.
          setCurrPlant({ ...areas[areaIndex].plants[plantIndex] })
          onUpdateArea(areas[areaIndex])
      } else {
          setCurrPlant(plant)
          onUpdateCustomPlant(plant)
      }
  }

   const generatePdf = () => {
        // Create a new instance of jsPDF
       var doc = new jsPDF('p', 'pt', 'letter');
       doc.setFontSize(28);
       doc.setDrawColor(0);
       // Add a title
       doc.text('My PDF Title', 20, 20);

       // Add some content
       doc.setFontSize(12);
       doc.text('This is some PDF content.', 20, 30);
       const blob = doc.save('blob.pdf');
       

  };

  function cancelCustomPlant() {
      setSaveCustomPlantModal(false)
  }

  function postCustomPlant (plant) {
     var plantData = areas[customAreaIndex].plants[customPlantIndex]
     plantData.name = name
     plantData.id = uuidv4()
     plantData.username = username
     if (selectedFiles.length>0) {
	 // save icon to S3
         plantData.icon = selectedFiles[0].name
	 var file = selectedFiles[0]
	  Storage.put(username+"-"+file.name, file, {
               contentType: file.type
          }).then (result => {
             console.log(result)
          })
          .catch(err => {
             console.log(err)
          });
     } 
     onSaveCustomPlant(plantData)
     onGetCustomPlants()
     setSaveCustomPlantModal(false)
  }


  function handleAcceptedFiles(files) {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: formatBytes(file.size)
      })
    )

    setSelectedFiles(files)
  }

  function restoreSpaceUsed(areaIndex) {
      var spaceUsed = 0;

      userareas[areaIndex].plants.map(plant => {
           spaceUsed += parseFloat(plant.spaceUsed);
         });

      userareas[areaIndex].spaceUsed = spaceUsed;
      setAreas(userareas)
  }

  return (
<div ref={drag}>
  <Card outline color="secondary" className="border"
        outline
        color="secondary"
        className="border"
        style={{
            backgroundColor:
                ["Complete", "Completed", "Failed"].includes(plant.status)
                    ? "#b8babc" // light grey
                    : "#ffffff",
            border: "2px solid #dee2e6"
        }}>
    <CardBody  style={{margin:"5px", padding:"2px", border:"2px"}} >
        <Row>
            <Col md={12} onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer"}}>

                <StorageImage
                              alt={plant.species}
                              imgKey={plant.cardIconKey ? plant.cardIconKey :
                                  "card_icons/" + plant.species.toLowerCase().replace(/[‘’’‛`´]/g, "")
                                      .replace(/[^a-z0-9]+/g, "_")
                                      .replace(/^_+|_+$/g, "")+".png"}
                              accessLevel="guest"
                              onStorageGetError={(error) => console.error(error)}
                              style={{ width: "100%", height: "auto", maxWidth: "324px", display: "block", margin: "auto" }}
                />
            </Col>
        </Row>
        <Row style={{ cursor: "pointer"}}>
            <Col md={8} onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer"}}><span style={{fontSize:"1.2em", padding:"-10px 0"}}>{plant.species}</span></Col>
            <Col md={4}>
                <div className="btn-group" role="group">
                    <button type="button" className="btn btn-sm" title="Split Plants" style={{ background:"none", border:"none", color:"#212529", padding:"2px 6px" }} onClick={e => { transferPlant(areaIndex, plantIndex) }}>
                        <i className="bx bx-export" style={{ fontSize:"1.2rem" }} />
                    </button>
                    <button type="button" className="btn btn-sm" style={{ background:"none", border:"none", color:"#D64545", padding:"2px 6px" }} onClick={e => { deletePlant(areas[areaIndex].id, plantIndex) }}>
                        <i className="bx bx-trash" style={{ fontSize:"1.2rem" }} />
                    </button>
                </div>
            </Col>
        </Row>
        <Row>
            <Col md={6}>Variety</Col>
            <Col md={6}><i>{plant.variety}</i></Col>
        </Row>
        <Row onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer" }}>
            <Col md={6}>Season</Col>
            <Col md={6}>{plant.season_rotation}</Col>
        </Row>
        <Row onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer" }}>
            <Col md={6}>Status</Col>
            <Col md={6}>{plant.status}</Col>
        </Row>
        <Row onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer" }}>
            <Col md={6}>Harvest ({unitmeasurement=="imperial"?"lb":"kg"})</Col>
            <Col md={6}>
                {parseFloat(plant.totalHarvest/16 || 0).toFixed(2)}
                {" / "}
                {typeof plant.estHarvest != 'number' ? 'N/A' : parseFloat(plant.estHarvest).toFixed(2)}
            </Col>
        </Row>
        <Row onClick={()=> {editPlant(plant, areaIndex, plantIndex)}} style={{ cursor: "pointer" }}>
            <Col md={6}>Space Used ({unitmeasurement=="imperial"?"ft²":"m²"})</Col>
            <Col md={6}>{parseFloat(plant.spaceUsed).toFixed(2)}</Col>
        </Row>
     </CardBody>
</Card>

 <Modal className="modal-dialog-scrollable" isOpen={plantModal} onHide={!plantModal}	 toggle={() => {
                        editPlant()
 }}
>
    <ModalHeader tag="h4">
        <Row>
	  <Col md={6}>
	  {currPlant.species}
	  </Col>
	  </Row>

    </ModalHeader>
    <ModalBody style={{ padding:0 }}>
	{ !profileView &&
       <Form>
         {/* ── Summary strip ── */}
         <div style={{ display:"flex", backgroundColor:"#DDE5D7", marginBottom:0, border:"1px solid #c8d4c0" }}>
             {[
                 { label:"Variety", content: <Editable name="variety" value={currPlant.variety} display={v => <span style={{color:"black"}}>{v}</span>} dataType="text" showButtons={true} handleSubmit={plantChange} /> },
                 ...((currPlant.season || "").toLowerCase() !== "perennial"
                     ? [{ label:"Season",  content: <Editable name="season_rotation" value={currPlant.season_rotation} dataType="select" showButtons={false} display={v => <span style={{color:"black"}}>{v}</span>} options={plantSeasonOptions} mode="inline" handleSubmit={plantChange} /> }]
                     : []),
                 { label:"Status",  content: <Editable name="status" value={currPlant.status} dataType="select" showButtons={false} display={v => <span style={{color:"black"}}>{v}</span>} options={plantStatusOptions} mode="inline" handleSubmit={plantChange} /> },
                 { label:"# Plants", content: <Editable name="numPlants" value={currPlant.numPlants} dataType="text" showButtons={false} display={v => <span style={{color:"black"}}>{v}</span>} mode="inline" handleSubmit={plantChange} /> },
             ].map(({ label, content }, i, arr) => (
                 <div key={label} style={{ flex:1, padding:"6px 8px", textAlign:"center", borderRight: i < arr.length - 1 ? "2px solid black" : "none" }}>
                     <div style={{ fontSize:"0.72rem", color:"#555", marginBottom:2, textTransform:"uppercase", letterSpacing:"0.04em" }}>{label}</div>
                     {content}
                 </div>
             ))}
         </div>

                    {currPlant.status=="Purchased" && currPlant.plantSource && currPlant.plantSource!='' &&
                        <Row style={{lineHeight:"2em"}}>
                            <Col md={6}>Plant Source</Col>
                            <Col md={6}>
                                <Editable
                                    name="plantSource"
                                    value={currPlant.plantSource}
                                    display={(value) => {
                                        return (<span style={{color:"black"}}>{value}</span>);
                                    }}
                                    dataType="text"
                                    showButtons={false}
                                    mode="inline"
                                    handleSubmit={plantChange}
                                />
                            </Col>
                        </Row>
                    }
           {currPlant.status=="Purchased" && currPlant.orderDate && currPlant.orderDate!='' &&
               <Row style={{lineHeight:"2em"}}>
                   <Col md={6}>Order Date</Col>
                   <Col md={6}>
                       <Editable
                           name="orderDate"
                           value={currPlant.orderDate}
                           display={(value) => {
                               return (<span style={{color:"black"}}>{value}</span>);
                           }}
                           dataType="date"
                           showButtons={false}
                           mode="inline"
                           handleSubmit={plantChange}
                       />
                   </Col>
               </Row>
           }
           {currPlant.status=="Purchased" && currPlant.expectedDeliveryDate &&
               <Row style={{lineHeight:"2em"}}>
                   <Col md={6}>Expected Delivery</Col>
                   <Col md={6}>
                       <Editable
                           name="expectedDeliveryDate"
                           value={currPlant.expectedDeliveryDate}
                           display={(value) => {
                               return (<span style={{color:"black"}}>{value}</span>);
                           }}
                           dataType="text"
                           showButtons={false}
                           mode="inline"
                           handleSubmit={plantChange}
                       />
                   </Col>
               </Row>
           }
                    {/* ── Tabs ── */}
                    <div style={{ backgroundColor:"#D9DEE5", borderBottom:"2px solid #b8c0cc", display:"flex" }}>
                        {[
                            { id:"info", label:"Info" },
                            { id:"dates", label:"Planting Dates" },
                            ...(!customPlantEdit ? [{ id:"harvests", label:"Harvests" }] : []),
                            { id:"notes", label:"Notes" },
                        ].map(({ id, label }) => (
                            <button
                                key={id}
                                type="button"
                                onClick={() => setEditTab(id)}
                                style={{
                                    background:"none", border:"none", padding:"8px 16px",
                                    marginBottom:"-2px",
                                    borderBottom: editTab === id ? "2px solid #495057" : "2px solid transparent",
                                    color: editTab === id ? "#212529" : "#6c757d",
                                    fontWeight: editTab === id ? 600 : 400,
                                    cursor:"pointer",
                                }}
                            >
                                {label}
                            </button>
                        ))}
                    </div>
                    <TabContent activeTab={editTab} style={{ paddingLeft:"1.25rem", paddingRight:"1.25rem", paddingTop:"20px", paddingBottom:"20px" }}>
                        <TabPane tabId="info">
                            {Object.keys(currPlant).map((property) => (
                                property in plantProps && <Row style={{lineHeight:"2em"}} key={property}>
                                    <Col md={6}>{plantProps[property]}</Col>
                                    <Col md={6} style={{textAlign:"right"}}>
                                        <Editable name={property} value={currPlant[property]} showButtons={false}
                                            display={(value) => <span style={{color:"black"}}>{value}</span>}
                                            dataType="text" mode="inline" handleSubmit={plantChange}
                                        />
                                    </Col>
                                </Row>
                            ))}
                        </TabPane>
                        <TabPane tabId="dates">

                          <Row style={{ paddingTop: "10px"}}>
              <Col md="12">
                  {currPlant.seedStartDate && currPlant.harvestDate && rechartsClimate.length > 0 && (

                      <ResponsiveContainer width="100%" height={300}>
                      <AreaChart data={rechartsClimate}>
                          <XAxis
                              dataKey="date"
                              type="number"
                              scale="time"
                              domain={['dataMin', 'dataMax']}
                              tickFormatter={(ts) => dayjs(ts).format("MMM")}  // or use Date()
                          />

                          <YAxis />

                          {/* Cold average curve */}
                          <Area
                              type="monotone"
                              dataKey="cold"
                              fill="#2563eb"
                              stroke="#1d4ed8"
                              fillOpacity={0.25}
                          />

                          {/* Hot average curve */}
                          <Area
                              type="monotone"
                              dataKey="hot"
                              fill="#f87171"
                              stroke="#ef4444"
                              fillOpacity={0.25}
                          />

                          {/* Planting Window Rectangle */}
                          <ReferenceArea
                              x1={Date.parse(currPlant.seedStartDate)}
                              x2={Date.parse(currPlant.harvestDate)}
                              y1={minCold}
                              y2={maxHot}
                              fill="#00E396"
                              fillOpacity={0.5}
                              stroke="#00E396"
                          />

                          <Legend verticalAlign="bottom" height={36} />
                      </AreaChart>
                  </ResponsiveContainer>
                      )}

              </Col>
            </Row>
	 <Row>
                         <Col md={12}>
                           <table class="table">
                               <tr>
                                  <th></th>
                                  <th>Estimated</th>
                                  <th>Actual</th>
                               </tr>
                               <tr>
                                   <td>Seed Starting Date</td>
                                   <td>
                                <Editable
                                      name="seedStartDate"
                                      value={currPlant.seedStartDate}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      showButtons={false}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                  </td>
                                  <td> <Editable
                                      name="actualSeedStartDate"
                                      value={currPlant.actualSeedStartDate}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      showButtons={false}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                  </td>
                             </tr>
<tr>
                                <td>Transplant Date</td>
                                <td><Editable
                                      name="transplantDate"
                                      value={currPlant.transplantDate}
                                      dataType="date"
                                      showButtons={false}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                </td>
                                <td><Editable
                                      name="actualTransplantDate"
                                      value={currPlant.actualTransplantDate}
                                      dataType="date"
                                      showButtons={false}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                </td>
                             </tr>
 <tr>
                                <td>Harvest Date</td>
                                <td>
                                <Editable
                                      name="harvestDate"
                                      value={currPlant.harvestDate}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      showButtons={false}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                </td>
                                <td >
                                <Editable
                                      name="actualHarvestDate"
                                      value={currPlant.actualHarvestDate}
                                      display={(value) => {
                                         return (<span style={{color:"black"}}>{value}</span>);
                                      }}
                                      showButtons={false}
                                      dataType="date"
                                      mode="inline"
                                      handleSubmit={plantChange}
                      />
                                </td>
                            </tr>
                           </table>
                         </Col>
                      </Row>
                        </TabPane>
                        {!customPlantEdit && <TabPane tabId="harvests">

                             <ReactApexChart
                                  key={chartKey}
                                  options={harvestPlotOptions}
                                  series={currHarvests}
                                  id="harvestLog"
                                  type="line"
                                  height="150"
                             />
	                    <Row>
                      
                            <Col md={4}>Date</Col>
	                    <Col md={4}>Amount (ounces)</Col>
	                    </Row>
                      {currPlant && currPlant.harvests && currPlant.harvests.map((harvest)=>(
                       <Row>
                          <Col md={4}>{harvest.date}</Col>
                          <Col md={4}>{harvest.amount}</Col>
                          <Col md={2}>
                                <button type="button" className="btn btn-sm" style={{ background:"none", border:"none", color:"#D64545" }} onClick={e => { deleteHarvest(harvest.date, currPlant) }}>
                                    <i className="bx bx-trash" />
                                </button>
                           </Col>
                      </Row>
                 


                        ))}
	                     <Row>
	                        <Col md={4}><Input 
                                      name="harvestDate"
                                      value={harvestDate}
                                      type="date"
                                      onChange={event => {
                                         setHarvestDate(event.target.value);
                                      }}
                                />
                            </Col>
                            <Col md={4}> <Input
                                      name="harvestAmount"
                                      value={harvestAmount}
                                      type="text"
                                      onChange={event=> {
                                         setHarvestAmount(event.target.value);
                                      }}
                                /> 
                            </Col>
                            <Col>
                                <button type="button" className="btn btn-sm" style={{ backgroundColor:"#FF9900", borderColor:"#FF9900", color:"#fff" }} onClick={e => {
                                    const existing = Array.isArray(currPlant.harvests) ? currPlant.harvests : (currPlant.harvests?.L || [])
                                    const newHarvests = [...existing, { date: harvestDate, amount: harvestAmount }]
                                    addHarvest(plant, harvestDate, harvestAmount)
                                    setCurrPlant(prev => ({
                                        ...prev,
                                        harvests: newHarvests,
                                        totalHarvest: newHarvests.reduce((s, h) => s + parseFloat(h.amount || 0), 0),
                                    }))
                                    setHarvestDate("")
                                    setHarvestAmount("")
                                }}>
                                    Add Harvest
                                </button>
                            </Col>

	                    </Row>
                        </TabPane>}
                        <TabPane tabId="notes">

                        {(Array.isArray(timelineNotes) ? timelineNotes.filter(n => n.plant_id === plant.id) : []).map(note => {
                            const photos = normPhotos(note);
                            return (
                                <Card key={note.note_id} style={{ backgroundColor: "#f4f7f3", marginBottom: 8 }}>
                                    <CardHeader style={{ backgroundColor: "#f4f7f3", borderBottom: "none", display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px" }}>
                                        <div style={{ display: "flex", gap: 6, alignItems: "center", flexWrap: "wrap" }}>
                                            <span style={{ fontSize: 13, fontWeight: 600, color: "#4a6741" }}>{note.date}</span>
                                            <span className="note-tag">📍 {areas[areaIndex]?.name}</span>
                                            <span className="note-tag">🌿 {plant.species || plant.name}</span>
                                        </div>
                                        <Button color="danger" size="sm" onClick={() => deleteNote(note.note_id)}>Delete</Button>
                                    </CardHeader>
                                    <CardBody style={{ backgroundColor: "#f4f7f3", padding: "8px 12px" }}>
                                        {note.note_text && (
                                            <div style={{ color: "rgba(0,0,0,0.75)", lineHeight: 1.5, marginBottom: photos.length ? 10 : 0 }}>
                                                {note.note_text}
                                            </div>
                                        )}
                                        {photos.length > 0 && (
                                            <div>
                                                <div style={{ fontSize: 12, color: "rgba(0,0,0,0.5)", marginBottom: 6 }}>Photos ({photos.length})</div>
                                                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                                                    {photos.map(p => {
                                                        const url = photoUrlByKey[p.s3_key];
                                                        return (
                                                            <div key={p.s3_key} style={{ border: "1px solid rgba(0,0,0,0.06)", borderRadius: 10, padding: 6 }}>
                                                                {url ? (
                                                                    <img src={url} alt={p.comment || "photo"}
                                                                        style={{ width: 80, height: 80, objectFit: "cover", borderRadius: 8, cursor: "pointer" }}
                                                                        onClick={() => setLightboxUrl(url)}
                                                                    />
                                                                ) : (
                                                                    <div style={{ width: 80, height: 80, display: "flex", alignItems: "center", justifyContent: "center", background: "rgba(0,0,0,0.03)", borderRadius: 8, fontSize: 11, color: "rgba(0,0,0,0.5)" }}>Loading…</div>
                                                                )}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                    </CardBody>
                                </Card>
                            );
                        })}

                        <Row>
                            <Col md={6} style={{ marginTop: "30px" }}>
                                <b>Add Note</b>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={12}>
                                <Dropzone
                                    style={{
                                        width: "100%",
                                        height: "20%",
                                        border: "1px solid black",
                                    }}
                                    onDrop={acceptedFiles => {
                                        handleAcceptedFiles(acceptedFiles);
                                        setNoteError("");
                                    }}
                                >
                                    {({ getRootProps, getInputProps }) => (
                                        <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                        >
                                            <input {...getInputProps()} />
                                            <h4>Click here to upload Photo</h4>
                                        </div>
                                    )}
                                </Dropzone>
                            </Col>
                        </Row>

                        <Row>
                            <Col md={6}>
                                {selectedFiles.map((f, i) => (
                                    <Card
                                        className="mt-1 mb-0 shadow-none border"
                                        key={i}
                                    >
                                        <div className="p-2">
                                            <Row className="align-items-center">
                                                <Col className="col-auto">
                                                    <img
                                                        height="80"
                                                        className="avatar-sm rounded bg-light"
                                                        alt={f.name}
                                                        src={f.preview}
                                                    />
                                                </Col>
                                                <Col>
                                                    <div className="text-muted font-weight-bold">
                                                        {f.name}
                                                    </div>
                                                    <p className="mb-0">
                                                        <strong>{f.formattedSize}</strong>
                                                    </p>
                                                </Col>
                                            </Row>
                                        </div>
                                    </Card>
                                ))}
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}><b>Area</b></Col>
                            <Col md={9}><span>{areas[areaIndex]?.name || ""}</span></Col>
                        </Row>

                        <Row>
                            <Col md={3}><b>Plant</b></Col>
                            <Col md={9}><span>{plant.species || plant.name || ""}</span></Col>
                        </Row>

                        <Row>
                            <Col md={3}><b>Date</b></Col>
                            <Col md={9}>
                                <Input
                                    name="note"
                                    type="date"
                                    value={noteDate}
                                    onChange={e => {
                                        setNoteDate(e.target.value);
                                        setNoteError("");
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row>
                            <Col md={3}><b>Notes</b></Col>
                            <Col md={9}>
          <textarea
              className="form-control"
              value={notes}
              onChange={e => {
                  setNotes(e.target.value);
                  setNoteError("");
              }}
          />
                            </Col>
                        </Row>

                        {noteError && (
                            <Row>
                                <Col md={12}>
                                    <div className="text-danger mt-2">
                                        {noteError}
                                    </div>
                                </Col>
                            </Row>
                        )}

                        <Row className="mt-3">
                            <Col md={2}>
                                <button type="button" className="btn btn-sm" style={{ backgroundColor:"#FF9900", borderColor:"#FF9900", color:"#fff" }} onClick={addPlantLog}>
                                    Add <i className="bx bx-photo-album" />
                                </button>
                            </Col>
                        </Row>

                        </TabPane>
                    </TabContent>
               </Form>
	}
	  {profileView &&
	  <Row>
            <Col md={4}>

         <StorageImage
      width="100px" alt={currPlant.name + "-icon"}
      imgKey={username+"-"+currPlant.icon}
      accessLevel="guest"
      onStorageGetError={(error) => console.error(error)}
    />
             </Col>
             <Col md={8}>
                 <Row>
                    <Col md={12}>
                        {currPlant.name}
                    </Col>
                  </Row>
                   <Row>
                    <Col md={12}>
                        {currPlant.species}
                    </Col>
                  </Row>
                   <Row>
                    <Col md={12}>
                        {currPlant["latin name"]}
                    </Col>
                  </Row>
              </Col>
          </Row>
}
     </ModalBody>
  </Modal>

  <Modal isOpen={saveCustomPlantModal} toggle={() => {

 }}
>
    <ModalHeader tag="h4">
        Save Custom Plant
    </ModalHeader>
    <ModalBody>
       <Form>
         <Row>
              <Col md={6}><b>Name of Saved Plant</b></Col>
              <Col md={6}>
                    <Input type="text" value={name} onChange={event => {
                               setName(event.target.value);
                          }}
/>
              </Col>
         </Row>
	  <Row style={{"marginTop": "10px", "marginBottom": "10px"}}>
              <Col md={6}><b>Choose photo to identify custom plant</b></Col>
          {selectedFiles.length==0 && <Col md={6}>
                   <Dropzone
                      style={{"width" : "100%", "height" : "20%", "border" : "1px solid black"}}
                      onDrop={acceptedFiles => {
                           handleAcceptedFiles(acceptedFiles)
                      }}
                   >
             {({ getRootProps, getInputProps }) => (
                  <div
                className="dz-message needsclick" style={{"backgroundColor": "#DDDDDD"}} 
                      {...getRootProps()}
               >
                  <input {...getInputProps()} />
                  <h4>Click to upload Photo</h4>
               </div>
         )}
      </Dropzone>
          </Col>}

	  {selectedFiles.length>0 &&
          <Col md={6}>
           {selectedFiles.map((f, i) => {
                            return (
                              <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + "-file"}
                              >
                                <div className="p-2">
                                  <Row className="align-items-center">
                                    <Col className="col-auto">
                                      <img
                                        data-dz-thumbnail=""
                                        height="80"
                                        className="avatar-sm rounded bg-light"
                                        alt={f.name}
                                        src={f.preview}
                                      />
                                    </Col>
                                    <Col>
                                      <Link
                                        to="#"
                                        className="text-muted font-weight-bold"
                                      >
                                        {f.name}
                                      </Link>
                                      <p className="mb-0">
                                        <strong>{f.formattedSize}</strong>
                                      </p>
                                    </Col>
                                  </Row>
                                </div>
                              </Card>
                            )
                          })}
                     </Col>}
          </Row>
         <Row style={{ paddingTop: "10px"}}>
              <Col md="5"/>
              <Col md="4">
                   <Button
                       onClick={e => { postCustomPlant()  }}
                       color="success"
                       className="btn-sm"
                    >
                     Save 
                   </Button>
              </Col>
	      <Col md="2">
                  <Button
                       onClick={e => { cancelCustomPlant()  }}
                       color="primary"
                       className="btn-sm"
                    >
                     Cancel
                   </Button>
              </Col>

            </Row>

        </Form>
    </ModalBody>
</Modal>

    {/* Lightbox */}
    {lightboxUrl && (
        <div onClick={() => setLightboxUrl(null)}
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 9999, display: "flex", alignItems: "center", justifyContent: "center", cursor: "zoom-out" }}>
            <img src={lightboxUrl} alt="full size" style={{ maxWidth: "90vw", maxHeight: "90vh", borderRadius: 8 }} />
        </div>
    )}

</div>
   );
}
export default Plant;
